import { useNavigate } from 'react-router-dom'
import CircularProgress from '@mui/material/CircularProgress'

import * as S from './style'
import theme from '../../../theme'
import { TextSmallBold } from '../../Typography'
import colors from '../../../theme/colors'

const NavButton = ({
  variant = 'primary',
  loading,
  handleClick,
  disabled,
  to,
  external,
  children,
  ...props
}) => {
  const history = useNavigate();

  const onClick = (e) => {
    if (external) return;
    if (to) history.push(to);
    if (handleClick instanceof Function) handleClick(e);
  };

  if (external) {
    props.href = to;
    props.target = '_blank';
  }

  return (
    <S.NavButton
      type="button"
      variant={colors.neutral.shades.shade50}
      disabled={disabled}
      onClick={onClick}
      as={external ? 'a' : 'button'}
      tabIndex={0}
      loading={loading}
      {...props}
    >
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        {props.icon &&
          <div style={{ display: 'flex', alignItems: 'center', lineHeight: 24, paddingRight: children ? 10 : 0 }}>
            {props.icon}
          </div>
        }
        <TextSmallBold color={colors.neutral.shades.shade50}>
          <S.InnerTextAlign {...props} >{children}</S.InnerTextAlign>
        </TextSmallBold>
      </div>
      {
        loading && (
          <CircularProgress
            size={20}
            style={{ color: theme.colors.neutral.shades.shade50, marginLeft: '0.5rem', fontSize: 20 }}
          />
        )}
    </S.NavButton>
  );
}

export default NavButton
